<template>
    <div>
        <pageheading/>
        <div class="uk-padding" >
            <div class="uk-container">

                <ul class="uk-list uk-list-divider ">
                    <li>

                        <div>
                            <p>
                                DR. LINCOLN EDWARDS, president of Northern Caribbean University (NCU) has announced
                                the attainment of institutional accreditation status from the University Council of Jamaica
                                effective February 17, 2018 for a period of seven years.
                            </p>
                            <p>
                                The NCU President made the announcement on Thursday during a press conference at
                                the university’s main campus in Mandeville.
                                He said that the major significance of gaining Institutional Accreditation Status is that
                                Northern Caribbean University now has the authority, ability and capacity to develop and offer
                                degree programmes without the need for approval from the University Council of Jamaica.
                            </p>
                            <p>
                                Dr. Edwards pointed out that Northern Caribbean University is the second tertiary
                                education institution operating in Jamaica that enjoys institutional accreditation status.
                                He noted that the general benefits of accreditation include:
                            </p>
                            <ul class="uk-list uk-list-bullet">
                                <li>
                                    Affirmation by the government, regional/national accreditation agencies, or professional
                                    organizations enhances marketability and makes graduates more employable.
                                </li>
                                <li>
                                    Credits earned are transferable to other schools.
                                </li>
                                <li>
                                    Students who earn a degree from an accredited institution find it easier to gain acceptance
                                    for advanced studies at other schools and qualify for exams that license them for the
                                    practice of various professions.
                                </li>
                                <li>
                                    Accreditation provides public assurance that new graduates have acquired the necessary
                                    knowledge, competence and skills to enter the profession for which they have studied.
                                </li>
                                <li>
                                    Through the accreditation process, the institution demonstrates how it aligns its efforts
                                    and resources to deliver on its value proposition.
                                </li>
                                <li>
                                    The process promotes transparency and demonstrates accountability to the stakeholders.
                                </li>
                                <li>
                                    The accreditation process is cyclical and seeks to foster continuous quality improvement.
                                </li>
                            </ul>
                            <p>
                                Dr. Edwards expressed appreciation to the representatives of the University Council of Jamaica
                                and, by extension, the Ministry of Education, Youth and Information for their support and
                                guidance of the university in achieving the high standards required to gain institutional
                                accreditation status.
                            </p>
                        </div>
                    </li>

                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import Pageheading from "../components/shared/pageheading";
    export default {
        name: "Accreditation",
        components: {Pageheading}
    }
</script>

<style scoped>
    @media screen and (max-width:600px){


        h3{
            font-size: 1.4em !important;
        }
        p,li{
            font-size: 0.8em !important;
        }
        img{
            height: 40px !important;
        }

    }
</style>
